<template>
    <v-container fluid>
        <v-row v-if="loading" style="height: 80vh" justify="center" align="center">
            <v-progress-circular :size="50" :width="7" color="primary" indeterminate></v-progress-circular>
        </v-row>
        <span v-else>

            <v-btn absolute right class=" " color="primary" elevation="0" :loading="loadReport" small
                @click="downloadReport()">
                <v-icon x-small>mdi mdi-download</v-icon>

            </v-btn>
            <v-card-title class=" black--text text-h5 justify-center mb-3">
                Mesas testigo
            </v-card-title>
            <v-container fluid>
                <v-row>

                    <v-col cols="12" xl="4" lg="4" class="justify-center">
                        <v-card>
                            <v-card-text>
                                <apexchart :type="'donut'" :options="chartOptionsConDatos" :series="seriesConDatos">
                                </apexchart>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" xl="4" lg="4" class="justify-center">
                        <v-card>
                            <v-card-text>
                                <apexchart :type="'donut'" :options="chartOptions" :series="series">
                                </apexchart>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" xl="4" lg="4" class="justify-center">
                        <v-card>
                            <v-card-text>
                                <apexchart :type="'donut'" :options="chartOptionsConTelegrama" :series="seriesConTelegrama">
                                </apexchart>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                </v-row>
            </v-container>
            <v-container fluid>
                <v-row>
                    <v-col v-if="seriesVotosLinea.length > 0">
                        <v-card>
                            <v-card-text>

                                <apexchart type="line" height="450" :options="chartOptionsVotosLinea"
                                    :series="seriesVotosLinea[0]">
                                </apexchart>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

            </v-container>


            <v-container fluid>
                <v-row>
                    <v-col>
                        <v-data-table dense :headers="headers" :items="tendencia" class="elevation-1"
                            v-if="tendencia.length > 0">
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Mesas testigo</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>

                                    <v-btn class="d-print-none ml-3 " color="primary" small
                                        @click="descargarCSV(tendencia, 'testigos.csv', headers)">
                                        <v-icon>mdi-download</v-icon>CSV
                                    </v-btn>

                                </v-toolbar>
                            </template>

                            <template v-slot:no-data>
                                <v-btn color="primary" @click="initialize"> Recargar </v-btn>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </span>

        <informe v-if="tendencia.length && tendenciaLinea" ref="informe" @done="done($event)">
            <tendenciaInforme :tendencia="tendencia" :tendenciaLinea="tendenciaLinea"></tendenciaInforme>
        </informe>
    </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import TendenciaService from "@/services/TendenciaService";
import moment from 'moment'
import tendenciaInforme from '../components/informes/TendenciaInforme.vue'
import informe from '../components/informe.vue'


export default {
    name: "Tendencia",
    components: {
        informe,
        tendenciaInforme
    },
    data: () => ({

        loadReport: false,
        loading: true,
        intervalSeconds: 60,
        dialog: false,
        headers: [
            { text: "Establecimiento/Escuela", value: "ESTABLECIMIENTO_ESCUELA", sortable: true, align: 'left' },
            { text: "Provincia", value: "PROVINCIA", sortable: true, align: 'center' },
            { text: "Mesa número", value: "MESA", sortable: true, align: 'cneter' },
            { text: "Factor", value: "FEXP1", sortable: true, align: 'right' },
            { text: "Estrato", value: "ESTRATO", sortable: true, align: 'center' },
            { text: "UxP", value: "UxP", sortable: true, align: 'right' },
            // { text: "JxC", value: "JxC", sortable: true, align: 'right' },
            { text: "LLA", value: "LLA", sortable: true, align: 'right' },
            // { text: "Otros", value: "otros", sortable: true, align: 'right' },
            { text: "NH. Muestra total", value: "ocurrencia", sortable: true, align: 'right' },
            { text: "Ocu. Sin valor", value: "ocurrenciaSinValores", sortable: true, align: 'right', class: 'text-no-wrap' },
            { text: "Factor Expansión Ponderado", value: "factorActual", sortable: true, align: 'right' },
            { text: "UxP Ponderado", value: "UxP_Ponderado", sortable: true, align: 'right' },
            // { text: "JxC Ponderado", value: "JxC_Ponderado", sortable: true, align: 'right' },
            { text: "LLA Ponderado", value: "LLA_Ponderado", sortable: true, align: 'right' },
            // { text: "Otros Ponderado ", value: "otros_Ponderado", sortable: true, align: 'right' },
        ],
        tendencia: [],
        editedIndex: -1,
        chartOptions: {},
        series: [],
        chartOptionsConDatos: {},
        seriesConDatos: [],
        chartOptionsConTelegrama: {},
        seriesConTelegrama: [],


        seriesVotosLinea: [

        ],
        chartOptionsVotosLinea: {
            chart: {
                height: 450,
                type: 'line',
            },
            stroke: {
                show: true,
                // curve: 'smooth',
                lineCap: 'round',
                // dashArray: 10,
                width: [0, 4, 4, 4, 4],
            },
            title: {
                text: 'Porcentaje votos'
            },
            dataLabels: {
                enabled: false,
                enabledOnSeries: [0],
                formatter: function (val) {
                    return val
                },
                textAnchor: 'middle',
                distributed: false,
                offsetX: 0,
                offsetY: 0,
                style: {
                    fontSize: '14px',
                    fontFamily: 'Helvetica, Arial, sans-serif',
                    fontWeight: 'bold',
                    colors: ['#FFF']
                },
                background: {
                    enabled: false,
                    foreColor: '#fff',
                    padding: 4,
                    borderRadius: 2,
                    borderWidth: 1,
                    borderColor: '#fff',
                    opacity: 0.9,
                    dropShadow: {
                        enabled: false,
                        top: 1,
                        left: 1,
                        blur: 1,
                        color: '#000',
                        opacity: 0.45
                    }
                },
                dropShadow: {
                    enabled: false,
                    top: 1,
                    left: 1,
                    blur: 1,
                    color: '#000',
                    opacity: 0.45
                }
            },
            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: function (y) {
                        if (typeof y !== "undefined") {
                            return y + "%";
                        }
                        return y;

                    }
                }
            },
            labels: [],
            xaxis: {
                tickAmount: 50
            },
            yaxis: [
                {
                    title: {
                        text: 'Porcentaje de mesas escrutadas',
                    },
                    labels: {
                        formatter: (value) => value.toFixed(0) + '%',
                    },
                    min: 0,
                    max: 100,

                },
                {
                    opposite: true,
                    title: {
                        text: 'Porcentaje de votos'
                    },
                    labels: {
                        formatter: (value) => value.toFixed(0) + '%',
                    },
                    min: 0,
                    max: 100,
                }, {
                    show: false,
                    min: 0,
                    max: 100,
                }, {
                    show: false,
                    min: 0,
                    max: 100,
                }, {
                    show: false,
                    min: 0,
                    max: 100,
                }
            ],
        },
    }),

    watch: {

    },

    // created() {
    //     this.initialize();
    // },

    methods: {


        formatNumbers(value) {
            return new Intl.NumberFormat('es-AR').format(value);
        },


        done() {
            // console.log("temrino", event);
            this.loadReport = false;
        },

        downloadReport() {
            this.loadReport = true;
            this.$refs.informe.generateReport()
        },


        ...mapActions("general", ["showToast", "setNotification"]),
        async initialize() {

            let resu = await TendenciaService.all();
            this.tendencia = resu.data.tendencias;
            this.tendenciaLinea = resu.data.tendenciaLinea
            this.mapearSeries([resu.data.tendenciaLinea])
            let uxp = 0;
            // let jxc = 0;
            let lla = 0;
            // let otros = 0;
            let con_telegrama = 0;
            let con_datos = 0;
            this.tendencia.forEach(t => {

                t.UxP_Ponderado = Number(t.UxP_Ponderado.toFixed(2))
                // t.JxC_Ponderado = Number(t.JxC_Ponderado.toFixed(2))
                t.LLA_Ponderado = Number(t.LLA_Ponderado.toFixed(2))

                // t.otros_Ponderado = t.otros_Ponderado ? Number(t.otros_Ponderado.toFixed(2)) : 0

                uxp += t.UxP_Ponderado;
                // jxc += t.JxC_Ponderado;
                lla += t.LLA_Ponderado;
                // otros += t.otros_Ponderado ? t.otros_Ponderado : 0;
                t.TIENE_DATOS && (con_datos++);
                t.TIENE_TELEGRAMA && (con_telegrama++);
                t.MESA = `${t.PROVINCIA_COD.toString().padStart(2, '0')}${t.PARTIDO_COD.toString().padStart(3, '0')}${t.MESA_NRO.toString().padStart(5, '0')}X`;
                t.PROVINCIA = t.PROVINCIA + ' - ' + t.PARTIDO;
            });
            // this.series = [Math.round(uxp), Math.round(jxc), Math.round(lla), Math.round(otros)];
            this.series = [Math.round(uxp), Math.round(lla)];
            this.chartOptions = {
                title: {
                    text: "Total de votos ponderado por agrupación",
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: undefined,
                        color: '#263238'
                    },
                },

                theme: { palette: 'palette1' }, ...this.config(),
                colors: ['#009CDE', '#753BBD',],
                // colors: ['#009CDE', '#FEDD00', '#753BBD', '#808080'],
                labels: [`Union por la Patria: ${this.formatNumbers(Math.round(uxp))}`, `La libertad avanza: ${this.formatNumbers(Math.round(lla))}`]
            }
            this.seriesConTelegrama = [con_telegrama, this.tendencia.length - con_telegrama];
            this.chartOptionsConTelegrama = {
                title: {
                    text: "Mesas con telegramas recibidos",
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: undefined,
                        color: '#263238'
                    },
                },
                theme: { palette: 'palette4' }, ...this.configSinTotal(),
                labels: [`Mesas con telegrama: ${con_telegrama}`, `Sin telegrama aún: ${this.tendencia.length - con_telegrama}`]
            }
            this.seriesConDatos = [con_datos, this.tendencia.length - con_datos];
            this.chartOptionsConDatos = {
                title: {
                    text: "Mesas con datos digitados y totalizados",
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: undefined,
                        color: '#263238'
                    },
                },
                theme: { palette: 'palette3' }, ...this.configSinTotal(),
                labels: [`Mesas con datos digitados: ${con_datos}`, `Sin datos aún: ${this.tendencia.length - con_datos}`]
            }
            this.loading = false;
        },
        mapearSeries(resultados) {
            // console.log("🚀 ~ file: Tendencia.vue:383 ~ mapearSeries ~ resultados:", resultados)

            let auxseries = []

            let labels = []
            let auxdata = []
            // console.log(resultados);

            if (Object.keys(resultados).length > 0) {




                resultados.forEach((r) => {

                    auxdata = [
                        {
                            name: 'Mesas',
                            type: 'column',
                            data: [],
                            votos: [],
                            color: '#BDBDBD'
                        },
                        {
                            name: 'Union por la patria',
                            type: 'line',
                            data: [],
                            votos: [],
                            color: '#009cde'
                        },
                        // {
                        //     name: 'Juntos por el cambio',
                        //     type: 'line',
                        //     data: [],
                        //     votos: [],
                        //     color: '#FEDD00'
                        // },
                        {
                            name: 'La libertad avanza',
                            type: 'line',
                            data: [],
                            votos: [],
                            color: '#753BBD'

                        },

                        // {
                        //     name: 'Otros',
                        //     type: 'line',
                        //     data: [],
                        //     votos: [],
                        //     color: '#6E6E6E'
                        // }
                    ]

                    r.filtroDetalles.forEach((d) => {




                        auxdata[0].data.push(d.mesasTotalizadasPorcentaje)
                        auxdata[0].votos.push(d.mesasTotalizadas)

                        // auxdata[1].data.push(d.jxcporcentajevotos)
                        // auxdata[1].votos.push(d.jxcvotos)

                        auxdata[2].data.push(d.llaporcentajevotos)
                        auxdata[2].votos.push(d.llavotos)

                        auxdata[1].data.push(d.uxpporcentajevotos)
                        auxdata[1].votos.push(d.uxpvotos)

                        // auxdata[4].data.push(d.otroporcentajevotos)
                        // auxdata[4].votos.push(d.totalVotosOtro)

                        //  labels.push (4)
                        //  labels.push ()

                    })
                    // console.log("🚀 ~ file: Pronostico.vue:408 ~ resultados.forEach ~ r:", r)



                    auxseries.push(auxdata)
                    // this.auxseries[index].push(auxdata)
                })


                if (resultados.length) {
                    if (resultados[0].filtroDetalles.length > 0) {
                        resultados[0].filtroDetalles.forEach((d) => {
                            labels.push(moment(d.fechaTotalizacion).format('HH:mm'))
                        })

                    }
                }
            }

            this.chartOptionsVotosLinea.labels = labels
            this.seriesVotosLinea = auxseries

        }
        ,
        config() {
            return {
                plotOptions: {
                    pie: {
                        donut: {
                            size: "50%",
                            labels: {
                                show: false,
                                name: {
                                    show: true,
                                    fontSize: "5px",
                                    color: "#000",
                                },
                                value: {
                                    show: true,
                                    fontSize: "22px",
                                    fontWeight: "bold",
                                    color: "#000",
                                    offsetY: 16,
                                    formatter: (val) => {
                                        return Number(val).toLocaleString();
                                    },
                                },
                                total: {
                                    show: false,
                                    fontSize: "22px",
                                    label: "Total",
                                    fontWeight: "bold",
                                    color: "#000",
                                    // formatter: function (w) {
                                    //   return w.globals.seriesTotals.reduce(
                                    //     (a, b) => {
                                    //       return a + b;
                                    //     },
                                    //     0
                                    //   );
                                    // },
                                    formatter: () => {
                                        // console.log('char',votantes);
                                        return 0;
                                    },
                                },
                            },
                        },
                    },
                },
                chart: {
                    type: "donut",
                    width: '100%',
                    animations: {
                        enabled: false,
                        // easing: "easeinout",
                        speed: 800,
                        animateGradually: {
                            enabled: true,
                            delay: 150,
                        },
                        dynamicAnimation: {
                            enabled: true,
                            speed: 350,
                        },
                    },
                },
                legend: {
                    position: "bottom",
                    floating: false,
                    // formatter: function (seriesName, opts) {
                    //     return [seriesName, " - ", ((opts.w.globals.series[opts.seriesIndex] * 100) / opts.w.globals.series.reduce((prev, sig) => prev + sig, 0)).toFixed(1) + '%']
                    // }
                },
            }
        },
        configSinTotal() {
            return {
                plotOptions: {
                    pie: {
                        donut: {
                            size: "50%",
                        },
                    },
                },
                chart: {
                    type: "donut",
                    animations: {
                        enabled: true,
                        easing: "easeinout",
                        speed: 800,
                        animateGradually: {
                            enabled: true,
                            delay: 150,
                        },
                        dynamicAnimation: {
                            enabled: true,
                            speed: 350,
                        },
                    },
                },
                legend: {
                    position: "bottom",
                    floating: false,
                    // formatter: function (seriesName, opts) {
                    //     return [seriesName, " - ", ((opts.w.globals.series[opts.seriesIndex] * 100) / opts.w.globals.series.reduce((prev, sig) => prev + sig, 0)).toFixed(1) + '%']
                    // }
                },
            }
        },
        descargarCSV(csvData, fileName, cabeza = []) {
            let cabezainst = cabeza.map(cab => cab.text)
            const csv = [cabezainst, ...csvData.map(valores => {
                return {
                    ESTABLECIMIENTO_ESCUELA: valores.ESTABLECIMIENTO_ESCUELA,
                    PROVINCIA: valores.PROVINCIA,
                    MESA: valores.MESA,
                    FEXP1: valores.FEXP1,
                    ESTRATO: valores.ESTRATO,
                    UxP: valores.UxP,
                    // JxC: valores.JxC,
                    LLA: valores.LLA,
                    // otros: valores.otros,
                    ocurrencia: valores.ocurrencia,
                    ocurrenciaSinValores: valores.ocurrenciaSinValores,
                    factorActual: valores.factorActual,
                    UxP_Ponderado: valores.UxP_Ponderado,
                    // JxC_Ponderado: valores.JxC_Ponderado,
                    LLA_Ponderado: valores.LLA_Ponderado,
                    // otros_Ponderado: valores.otros_Ponderado,
                }
            })].map(item => {
                const values = Object.values(item);
                return values.map(value => `"${value}"`).join(",");
            }).join("\n");

            const blob = new Blob([csv], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            URL.revokeObjectURL(url);
        }
    },

    mounted() {
        // console.log("LLEgo");
        this.initialize();
        setInterval(() => {

            this.user?.username != null && this.initialize();
        }, this.intervalSeconds * 1000);


    },

    computed: {
        ...mapState(["user"]),
    }
};
</script>